import { render, staticRenderFns } from "./AddPromoCode.vue?vue&type=template&id=2cb84533&scoped=true&"
import script from "./AddPromoCode.vue?vue&type=script&lang=js&"
export * from "./AddPromoCode.vue?vue&type=script&lang=js&"
import style0 from "./AddPromoCode.vue?vue&type=style&index=0&id=2cb84533&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb84533",
  null
  
)

export default component.exports